/**
 * We keep this logic in a dedicated file for now because it might be useful to other parts of the Submissions module.
 * If it turns out it's not needed elsewhere, we can move it to the component file.
 */

import { TItem } from '@modules/items';
import { ESubmissionItemStatus, TResolvedSubmissionItem } from '../types/submissions.types';

/**
 * For each selected item in the submission that is active + found in resolvedItems,
 * we generate an array of "transitions."  Each transition includes:
 *  - item
 *  - date: the date of the new status in the pair
 *  - oldStatus, newStatus
 */
type TItemTransition = {
  resolvedItem: TItem;
  date: string; // new status date
  oldStatus: ESubmissionItemStatus;
  newStatus: ESubmissionItemStatus;
};

const getRecentItemTransitions = (resolvedSelectedItems: TResolvedSubmissionItem[]): TItemTransition[] => {
  const results: TItemTransition[] = [];

  resolvedSelectedItems.forEach((item) => {
    if (item.statusHistory.length < 2) return;

    const lastEntry = item.statusHistory[item.statusHistory.length - 1];
    const preLastEntry = item.statusHistory[item.statusHistory.length - 2];

    results.push({
      resolvedItem: item.resolvedItem,
      date: lastEntry.date, // the date of the new status
      oldStatus: preLastEntry.status,
      newStatus: lastEntry.status,
    });
  });

  return results.sort((a, b) => b.date.localeCompare(a.date)); // newest first
};

export default getRecentItemTransitions;
